// React and ReactDOM imports
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Main App component
import App from './App';

// Authentication utilities
import {
  configureCognito,
  getAuthenticatedUser,
  redirectUserBasedOnLocalstorage,
  startAuthentication,
} from './auth/authenticator';

// Context stores
import { GlobalStore } from './context/GlobalStore';
import { UserStore } from './context/UserStore';

// Performance monitoring
import reportWebVitals from './reportWebVitals';

// Styles and fonts
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

/**
 * Application Entry Point
 * Sets up authentication, context providers, and renders the main app
 */

// Create React root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Configure AWS Cognito authentication
configureCognito();
// TODO: Uncomment when storage configuration is needed
// configureStorage();

/**
 * Initialize authentication flow
 * Checks if user is authenticated and redirects accordingly
 */
const startAuth = async () => {
  if (!(await getAuthenticatedUser())) {
    // User not authenticated - start auth flow
    startAuthentication();
  } else {
    // User authenticated - redirect based on stored preferences
    redirectUserBasedOnLocalstorage();
  }
};

// Start authentication process
startAuth();

// Render the application with all necessary providers
root.render(
  <React.StrictMode>
    {/* Global application state */}
    <GlobalStore.store>
      {/* User-specific state */}
      <UserStore.store>
        {/* React Router for navigation */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </UserStore.store>
    </GlobalStore.store>
  </React.StrictMode>,
);

// Performance monitoring setup
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
